import { useTranslation } from 'react-i18next'

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from '@/components/ui/alert-dialog'

export const ConfirmDialog = ({
  title,
  description,
  isOpen,
  setIsOpen,
  onConfirm,
}: {
  title: string
  description?: string
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onConfirm: () => Promise<void>
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'generic.confirmDialog',
  })

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      {/* <AlertDialogTrigger>{triggerLabel}</AlertDialogTrigger> */}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setIsOpen(false)}>
            {t('cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onConfirm().then(() => {
                setIsOpen(false)
              })
            }}
          >
            {t('confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
